import { render, staticRenderFns } from "./SearchChatMessages.vue?vue&type=template&id=2797e67b&scoped=true&lang=pug&"
import script from "./SearchChatMessages.vue?vue&type=script&lang=js&"
export * from "./SearchChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./SearchChatMessages.vue?vue&type=style&index=0&id=2797e67b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797e67b",
  null
  
)

export default component.exports